import React, {useEffect} from 'react'
import { v4 as uuidv4 } from 'uuid'
import { LuDot } from 'react-icons/lu'
import useAdvisor from 'hooks/useAdvisor'
import TCModal from 'components/organisms/Modal/TCModal'
import LogoFooter from 'assets/icons/LogoFooter'
import { tncCodeList } from 'constant/tncCode'
import useTnC from 'hooks/useTnC'
import SmartLink from 'components/atoms/SmartLink'
import { FaInstagram, FaLinkedin, FaTiktok, FaYoutube } from 'react-icons/fa'
import NewsletterFooter from './NewsletterFooter'
import { useInView } from 'react-intersection-observer'
import SectionLayout from 'components/templates/SectionLayout'
import {useLocation} from 'react-router-dom'

const navList = [
  {
    id: uuidv4(),
    path: '/events',
    name: 'Connect Days'
  },
  {
    id: uuidv4(),
    path: '/blog',
    name: 'Blog'
  },
  {
    id: uuidv4(),
    path: '/about-tomazz',
    name: 'Tentang Kami'
  },
  {
    id: uuidv4(),
    path: '/support',
    name: 'Bantuan'
  }
]
const advisorNavList = [
  {
    id: uuidv4(),
    path: '/advisor',
    name: 'Temukan Partner',
    isNextUrl: false
  },
  {
    id: uuidv4(),
    path: '/pricing',
    name: 'Menjadi Partner',
    isNextUrl: true
  }
]
const Footer = () => {
  const { isUserAdvisor } = useAdvisor()
  const { openModal, modal, closeModal, tcContent, isFetchingTnC } = useTnC()
  const { ref: footerRef, inView } = useInView({
    threshold: 0.1, // aktif kalau 10% area footer terlihat
    triggerOnce: true
  })
  const location = useLocation();
  const buyerNavList = [
    {
      id: uuidv4(),
      path: '/buyer',
      name: 'Perusahaan Dijual'
    },
    {
      id: uuidv4(),
      path: `/${isUserAdvisor ? 'advisor' : 'buyer'}/listing/buy-company`,
      name: 'Profil Pembeli'
    },
    {
      id: uuidv4(),
      path: '/pricing/buyer',
      name: 'Harga Pembeli'
    }
  ]
  const sellerNavList = [
    {
      id: uuidv4(),
      path: '/seller',
      name: 'Perusahaan yang Dicari'
    },
    {
      id: uuidv4(),
      path: `/${isUserAdvisor ? 'advisor' : 'seller'}/listing/sell-company`,
      name: 'Jual Perusahaan'
    },
    {
      id: uuidv4(),
      path: '/pricing/seller',
      name: 'Harga Penjual'
    }
  ]

  const socialMedia = [
    {
      id: uuidv4(),
      icon: <FaInstagram className="h-5 w-5 hover:text-lighter fill-white" />,
      href: 'https://www.instagram.com/tomazz.id/'
    },
    {
      id: uuidv4(),
      icon: <FaLinkedin className="h-5 w-5 hover:text-lighter fill-white" />,
      href: 'https://www.linkedin.com/company/tomazz-indonesia/'
    },
    {
      id: uuidv4(),
      icon: <FaTiktok className="h-5 w-5 hover:text-lighter fill-white" />,
      href: 'https://www.tiktok.com/@tomazz.indonesia'
    },
    {
      id: uuidv4(),
      icon: <FaYoutube className="h-5 w-5 hover:text-lighter fill-white" />,
      href: 'https://www.youtube.com/@TomazzIndonesia'
    }
  ]

  useEffect(() => {
    const path = location.pathname;

    if (path.includes("/terms-and-conditions")) {
      openModal(tncCodeList.GENERAL);
    }

    if (path.includes("/privacy-policy")) {
      openModal(tncCodeList.PRIVACY_POLICY);
    }
  }, [location.pathname]);

  return (
    <footer
      ref={footerRef}
      className="w-full flex-col flex justify-between items-center bg-brand-default text-white border border-solid border-x-0 border-b-0 border-t-lighter">
      <SectionLayout>
        <NewsletterFooter inView={inView} />
      </SectionLayout>
      {/* NavBottom */}
      <SectionLayout className="grid w-full grid-cols-1 gap-8 px-4 py-8 sm:grid-cols-2 lg:grid-cols-4">
        {/* TOMAZZ */}
        <div className="flex flex-col gap-4  w-fit">
          <LogoFooter />
          <ul className="space-y-4 list-none">
            {navList.map((navItem) => {
              return (
                <li key={navItem.id}>
                  <SmartLink
                    isNextUrl={true}
                    href={navItem.path}
                    className="no-underline text-white hover:text-secondary cursor-pointer">
                    {navItem.name}
                  </SmartLink>
                </li>
              )
            })}
          </ul>
        </div>
        {/* Sektor Usaha */}
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-4  w-fit">
            <span className="text-xl font-bold">Pembeli</span>
            <ul className="space-y-4 list-none">
              {buyerNavList.map((navItem) => {
                return (
                  <li key={navItem.id}>
                    <SmartLink
                      isNextUrl={false}
                      href={navItem.path}
                      className="no-underline text-white hover:text-secondary cursor-pointer">
                      {navItem.name}
                    </SmartLink>
                  </li>
                )
              })}
            </ul>
          </div>
          {/* Social Media */}
          <div className="flex flex-col gap-4">
            <span className="text-xl font-bold">Follow us on</span>
            <SocialMediaList navList={socialMedia} />
          </div>
        </div>
        <div className="flex flex-col gap-4  w-fit">
          <span className="text-xl font-bold">Penjual</span>
          <ul className="space-y-4 list-none">
            {sellerNavList.map((navItem) => {
              return (
                <li key={navItem.id}>
                  <SmartLink
                    isNextUrl={false}
                    href={navItem.path}
                    className="no-underline text-white hover:text-secondary cursor-pointer">
                    {navItem.name}
                  </SmartLink>
                </li>
              )
            })}
          </ul>
        </div>
        <div className="flex flex-col gap-4  w-fit">
          <span className="text-xl font-bold">Partner</span>
          <ul className="space-y-3 list-none">
            {advisorNavList.map((navItem) => {
              return (
                <li key={navItem.id}>
                  <SmartLink
                    isNextUrl={navItem?.isNextUrl}
                    href={navItem.path}
                    className="no-underline text-white hover:text-secondary cursor-pointer">
                    {navItem.name}
                  </SmartLink>
                </li>
              )
            })}
          </ul>
        </div>
      </SectionLayout>
      {/* Copyright */}
      <div className="bg-surface-brand-1 w-full">
        <div className="mx-auto flex w-full max-w-[1920px] flex-col gap-4 p-4 text-sm lg:flex-row lg:items-center lg:justify-between lg:px-[156px]">
          <span className="text-primary">
            &copy; {new Date().getFullYear()} Tomazz Bizniz International. All rights reserved.
          </span>
          <div className="flex items-center gap-2 flex-nowrap">
            <span
              className="text-primary cursor-pointer hover:text-brand-default"
              onClick={() => openModal(tncCodeList.GENERAL)}>
              Syarat dan Ketentuan
            </span>
            <LuDot className="text-primary" />
            <span
              className=" text-primary cursor-pointer hover:text-brand-default"
              onClick={() => openModal(tncCodeList.PRIVACY_POLICY)}>
              Kebijakan Privasi
            </span>
          </div>
        </div>
      </div>
      {modal?.open ? (
        <TCModal
          open={modal?.open}
          onClose={closeModal}
          content={tcContent}
          isLoading={isFetchingTnC}
        />
      ) : null}
    </footer>
  )

  function SocialMediaList({ navList }) {
    return (
      <div className="flex items-center gap-4">
        {navList.map((v) => (
          <a
            key={v.id}
            href={`${v.href}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:cursor-default">
            {v.icon}
          </a>
        ))}
      </div>
    )
  }
}

export default Footer
